interface DocumentSentAtSource {
  sentAt?: Date | string | null;
  metadata?: {
    sentAt?: Date | string | null;
    sentTo?: Array<{ sentAt?: Date | string | null }>;
  };
  recipients?: Array<{ latestSend?: { sentAt?: Date | string | null } }>;
}

function toValidDate(raw: Date | string | null | undefined): Date | null {
  if (raw == null) return null;
  const d = raw instanceof Date ? raw : new Date(raw);
  return Number.isNaN(d.getTime()) ? null : d;
}

/**
 * Resolves the most recent send timestamp for a document from all known send sources.
 */
export function resolveLatestDocumentSentAt(
  doc: DocumentSentAtSource | null | undefined
): string | null {
  if (!doc) return null;

  const candidates: Date[] = [];

  const addCandidate = (raw: Date | string | null | undefined) => {
    const d = toValidDate(raw);
    if (d) candidates.push(d);
  };

  addCandidate(doc.sentAt);
  addCandidate(doc.metadata?.sentAt);

  if (Array.isArray(doc.metadata?.sentTo)) {
    for (const entry of doc.metadata.sentTo) {
      addCandidate(entry?.sentAt);
    }
  }

  if (Array.isArray(doc.recipients)) {
    for (const recipient of doc.recipients) {
      addCandidate(recipient?.latestSend?.sentAt);
    }
  }

  if (candidates.length === 0) return null;

  const latest = candidates.reduce((max, d) => (d.getTime() > max.getTime() ? d : max));
  return latest.toISOString();
}
